/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

export const PREVIEW_BACKGROUND_COLOR = '#334451';
export const PREVIEW_WIDTH = 942;
export const PREVIEW_HEIGHT = 350;
export const SHAPE_CONTAINER_LENGTH = 350;
export const GLUE_WIDTH = 296;
export const MIN_SCALE_RATIO = 1.0;
export const MAX_SCALE_RATIO = 2.0;
export const BUTTON_SCALE_STEP = 0.1;
export const WHEEL_SCALE_STEP = 0.005;
export const WHEEL_EVENT_DELAY = 100;
export const KEY_EVENT_DELAY = 200;
export const KEY_EVENT_ACCELERATION = 3;
export const BUTTON_ROTATION_DEGREES = 90;
export const BACKGROUND_SQUARE_SIZE = 16;
export const DEFAULT_CROPPER_SETTINGS = {
  shape: 'square',
  rotation: 0,
  scaleRatio: MIN_SCALE_RATIO,
  translateX: 0,
  translateY: 0,
  direction: 0
};